var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFabsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2038",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2038",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 39.182,
    viewBox: "0 0 124 39.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1629",
    "data-name": "\\u9577\\u65B9\\u5F62 1629",
    width: 124,
    height: 39.182,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2038-2",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2038",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1168",
    "data-name": "\\u30D1\\u30B9 1168",
    d: "M5.992,103.784l.42-2.38H19.5a1.486,1.486,0,0,0,1.4-1.19.981.981,0,0,0-.98-1.19H6.831l.417-2.363H20.334a1.5,1.5,0,0,0,1.4-1.19.974.974,0,0,0-.98-1.19H7.668l.423-2.4H21.177a2.924,2.924,0,0,1,2.936,3.587,4.2,4.2,0,0,1-1.334,2.363,3.071,3.071,0,0,1,.5,2.38,4.428,4.428,0,0,1-4.2,3.57Z",
    transform: "translate(-4.695 -71.996)",
    fill: "#1c6ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1169",
    "data-name": "\\u30D1\\u30B9 1169",
    d: "M103.891,103.784H90.8l2.1-11.9H105.99a2.913,2.913,0,0,1,2.939,3.57l-.839,4.76a4.458,4.458,0,0,1-4.2,3.57m-10.284-2.4h10.707a1.467,1.467,0,0,0,1.4-1.173l.839-4.76a.966.966,0,0,0-.98-1.19H94.863Z",
    transform: "translate(-71.152 -71.996)",
    fill: "#1c6ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1170",
    "data-name": "\\u30D1\\u30B9 1170",
    d: "M271.179,91.884h13.069l-.42,2.38H270.759a1.486,1.486,0,0,0-1.4,1.19l-.21,1.19h14.259l-.42,2.38H268.729l-.839,4.76h-2.379l1.469-8.33a4.443,4.443,0,0,1,4.2-3.57",
    transform: "translate(-208.045 -71.997)",
    fill: "#1c6ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1171",
    "data-name": "\\u30D1\\u30B9 1171",
    d: "M356.446,103.785h-2.753l-1.529-3.57h-8.158l-2.788,3.57h-2.753L346.8,93.04a2.937,2.937,0,0,1,2.244-1.156h1.019A1.937,1.937,0,0,1,351.9,93.04Zm-5.289-5.95-1.512-3.57h-1.02l-2.771,3.57Z",
    transform: "translate(-265.209 -71.997)",
    fill: "#1c6ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1172",
    "data-name": "\\u30D1\\u30B9 1172",
    d: "M438.565,103.784H425.479l2.1-11.9h13.086a2.909,2.909,0,0,1,2.922,3.57,4.367,4.367,0,0,1-1.32,2.38,3.108,3.108,0,0,1,.481,2.38,4.454,4.454,0,0,1-4.181,3.57m-10.284-2.4h10.707a1.482,1.482,0,0,0,1.4-1.173.974.974,0,0,0-.98-1.19H428.7Zm.836-4.743h10.707a1.487,1.487,0,0,0,1.4-1.19.981.981,0,0,0-.98-1.19H429.537Z",
    transform: "translate(-333.391 -71.997)",
    fill: "#1c6ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1173",
    "data-name": "\\u30D1\\u30B9 1173",
    d: "M523.785,102.959l-.42,2.38h-8.922a.732.732,0,0,0-.7.578.483.483,0,0,0,.49.595h5.948a2.433,2.433,0,0,1,2.447,2.992,3.689,3.689,0,0,1-3.5,2.958h-8.922l.417-2.363h8.922a.75.75,0,0,0,.7-.595.483.483,0,0,0-.491-.595h-5.948a2.426,2.426,0,0,1-2.447-2.992,3.689,3.689,0,0,1,3.5-2.958Z",
    transform: "translate(-399.785 -80.675)",
    fill: "#1c6ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1174",
    "data-name": "\\u30D1\\u30B9 1174",
    d: "M223.934,4.237,221.331,0l-1.174,25.659L228.031,0Z",
    transform: "translate(-172.507 0)",
    fill: "#1c6ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1175",
    "data-name": "\\u30D1\\u30B9 1175",
    d: "M191.4,86.971l3.757-3.482-1.065,4.685,4.727-.239-4.036,3.143,2.927,3.143-4.642-.239-.587,4.685-2.529-3.482-3.757,3.482,1.065-4.685-4.727.239,4.036-3.143-2.928-3.143,4.642.239.587-4.685Z",
    transform: "translate(-143.027 -65.419)",
    fill: "#ff8e22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1176",
    "data-name": "\\u30D1\\u30B9 1176",
    d: "M0,168.044l.621-3.526h6.74l-.133.756H2.154l-.488,2.77Zm2.891-1.4L3,166H6.777l-.113.64Z",
    transform: "translate(0 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1177",
    "data-name": "\\u30D1\\u30B9 1177",
    d: "M38.912,168.045c-2.225,0-3.722-.775-3.542-1.8s1.938-1.727,4.163-1.727h1.935c2.3,0,3.767.7,3.587,1.727s-1.951,1.8-4.208,1.8Zm2.068-.756c1.3,0,2.289-.422,2.391-1s-.736-1.009-2.036-1.009H39.4c-1.257,0-2.256.422-2.36,1.009s.737,1,2,1Z",
    transform: "translate(-27.703 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1178",
    "data-name": "\\u30D1\\u30B9 1178",
    d: "M90.284,168.044l-1.734-.96H86.12l.114-.645h3.031c.817,0,1.307-.218,1.373-.592s-.372-.572-1.167-.572h-4.01l-.488,2.769H83.307l.622-3.526H89.6c1.827,0,2.823.509,2.682,1.31-.1.577-.775.98-1.784,1.155l2.156,1.062Z",
    transform: "translate(-65.276 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1179",
    "data-name": "\\u30D1\\u30B9 1179",
    d: "M150.173,167.868l-.949-.834h-3.3l.867-.587h1.762l-1.238-1.086-3.721,2.507h-1.9l5.027-3.332a1.468,1.468,0,0,1,.849-.243,1.1,1.1,0,0,1,.764.243l3.851,3.332Z",
    transform: "translate(-111.025 -128.734)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1180",
    "data-name": "\\u30D1\\u30B9 1180",
    d: "M193.524,168.044l.622-3.526h1.677l-.489,2.77h5.052l-.133.756Z",
    transform: "translate(-151.639 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1181",
    "data-name": "\\u30D1\\u30B9 1181",
    d: "M228.625,168.044l.622-3.526h1.677l-.488,2.77h5.052l-.133.756Z",
    transform: "translate(-179.143 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1182",
    "data-name": "\\u30D1\\u30B9 1182",
    d: "M278.521,168.045l.622-3.526h5.751c1.58,0,2.579.31,2.471.922-.075.427-.574.635-1.031.727.572.112.985.388.92.757-.123.7-1.24,1.12-2.777,1.12Zm2.908-1.494.105-.6h3.138c.613,0,.912-.111.953-.339.046-.262-.369-.344-1.089-.344h-3.848l-.357,2.023h3.977c.709,0,1.192-.117,1.238-.374.041-.233-.257-.369-.859-.369Z",
    transform: "translate(-218.239 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1183",
    "data-name": "\\u30D1\\u30B9 1183",
    d: "M322.957,168.045l.621-3.526h7.095l-.133.756h-5.429l-.355,2.013H330.2l-.133.756Zm2.907-1.494.105-.6h4.149l-.105.6Z",
    transform: "translate(-253.058 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1184",
    "data-name": "\\u30D1\\u30B9 1184",
    d: "M362.543,165.536l-.414,2.348h-1.591l.551-3.124c.048-.276.4-.446.917-.446a1.422,1.422,0,0,1,.652.141l4.726,2.217.414-2.348h1.6l-.556,3.158c-.05.281-.424.451-.918.451a1.418,1.418,0,0,1-.663-.145Z",
    transform: "translate(-282.505 -128.751)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1185",
    "data-name": "\\u30D1\\u30B9 1185",
    d: "M404.179,168.045l.622-3.526H411.9l-.133.756h-5.428l-.355,2.013h5.439l-.133.756Zm2.908-1.494.105-.6h4.149l-.105.6Z",
    transform: "translate(-316.701 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1186",
    "data-name": "\\u30D1\\u30B9 1186",
    d: "M441.911,168.044l.622-3.526h6.74l-.133.756h-5.074l-.488,2.77Zm2.892-1.4.113-.64h3.773l-.113.64Z",
    transform: "translate(-346.266 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1187",
    "data-name": "\\u30D1\\u30B9 1187",
    d: "M477.26,168.044l.622-3.526h1.677l-.622,3.526Z",
    transform: "translate(-373.965 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1188",
    "data-name": "\\u30D1\\u30B9 1188",
    d: "M493.612,168.044l.488-2.77h-2.87l.133-.756h7.417l-.133.756h-2.87l-.488,2.77Z",
    transform: "translate(-384.911 -128.911)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1189",
    "data-name": "\\u30D1\\u30B9 1189",
    d: "M526.907,168.044l.133-.756h5.9c.6,0,.971-.141,1.01-.364s-.278-.374-.88-.374h-3.537c-1.537,0-2.41-.417-2.3-1.014s1.061-1.019,2.684-1.019h5.654l-.133.756h-5.654c-.473,0-.784.121-.823.34s.242.339.7.339h3.515c1.645,0,2.468.33,2.344,1.033-.107.606-1.015,1.057-2.713,1.057Z",
    transform: "translate(-412.866 -128.911)",
    fill: "#333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabsLogo);
export default __webpack_public_path__ + "static/media/fabs_logo.55a56246c7bd5a5443f77503112d2521.svg";
export { ForwardRef as ReactComponent };